import { Module } from 'vuex'

interface ModalState {
  isShowLoginModal: boolean
  isShowProblemSearchModal: boolean
  isShowArenaModal: boolean
  isShowDashboardModal: boolean
  isShowUpdateModal: boolean
  isShowFreeSpaceModal: boolean
  isShowReviewAlertModal: boolean
  isShowSettingsModal: boolean
  isShowUserRegistrationModal: boolean
}

export const modalStateModule = (): Module<ModalState, any> => {
  return {
    namespaced: true,
    state: {
      isShowLoginModal: false,
      isShowProblemSearchModal: false,
      isShowArenaModal: false,
      isShowDashboardModal: false,
      isShowUpdateModal: false,
      isShowFreeSpaceModal: false,
      isShowReviewAlertModal: false,
      isShowSettingsModal: false,
      isShowUserRegistrationModal: false
    },
    mutations: {
      setIsShowLoginModal(state, isShowLoginModal: boolean) {
        state.isShowLoginModal = isShowLoginModal
      },
      setIsShowProblemSearchModal(state, isShowProblemSearchModal: boolean) {
        state.isShowProblemSearchModal = isShowProblemSearchModal
      },
      setIsShowArenaModal(state, isShowArenaModal: boolean) {
        state.isShowArenaModal = isShowArenaModal
      },
      setIsShowDashboardModal(state, isShowDashboardModal: boolean) {
        state.isShowDashboardModal = isShowDashboardModal
      },
      setIsShowUpdateModal(state, isShowUpdateModal: boolean) {
        state.isShowUpdateModal = isShowUpdateModal
      },
      setIsShowFreeSpaceModal(state, isShowFreeSpaceModal: boolean) {
        state.isShowFreeSpaceModal = isShowFreeSpaceModal
      },
      setIsShowReviewAlertModal(state, isShowReviewAlertModal: boolean) {
        state.isShowReviewAlertModal = isShowReviewAlertModal
      },
      setIsShowSettingsModal(state, isShowSettingsModal: boolean) {
        state.isShowSettingsModal = isShowSettingsModal
      },
      setIsShowUserRegistrationModal(state, isShowUserRegistrationModal: boolean) {
        state.isShowUserRegistrationModal = isShowUserRegistrationModal
      }
    },
    actions: {},
    getters: {
      isShowLoginModal: state => state.isShowLoginModal,
      isShowProblemSearchModal: state => state.isShowProblemSearchModal,
      isShowArenaModal: state => state.isShowArenaModal,
      isShowDashboardModal: state => state.isShowDashboardModal,
      isShowUpdateModal: state => state.isShowUpdateModal,
      isShowFreeSpaceModal: state => state.isShowFreeSpaceModal,
      isShowReviewAlertModal: state => state.isShowReviewAlertModal,
      isShowSettingsModal: state => state.isShowSettingsModal,
      isShowUserRegistrationModal: state => state.isShowUserRegistrationModal
    }
  }
}
